module.exports = __webpack_public_path__ + "static/media/visa.af4a5956.svg";